import { useState } from "react";
import axios from "axios";
import { UserOption } from "./formatTemplate";
import { getToken } from "@/utils/localstorage";

export default function useFetchUsers(searchQuery: string = "") {
  const [userOptions, setUserOptions] = useState<UserOption[]>([]);

  async function fetchUsers(email: string = searchQuery) {
    try {
      const apiUrl = process.env.API_URL;

      const authToken = await getToken();
      const response = await axios.get(`${apiUrl}/org/user?email=${email}&limit=10`, {
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      });
      const fetchedUsers: UserOption[] = response.data.map((user: { email: string }) => ({
        label: user.email,
        value: user.email,
      }));
      setUserOptions(fetchedUsers);
    } catch (err) {
      console.error("Error fetching users:", err);
    }
  }

  return { userOptions, fetchUsers };
}
